import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';
import { Box, IconButton } from '@mui/material';
import ExploreIcon from '@mui/icons-material/Explore';
import { createPortal } from 'react-dom';

import compassWhite from '../../assets/compass_white.png';
import compassBlack from '../../assets/compass_black.png';

const CompassControl = ({ position = 'topleft' }) => {
    const map = useMap();
    const isDarkMode = useSelector((state) => state.settings.darkMode);
    const [expanded, setExpanded] = useState(false);

    const compassImg = isDarkMode ? compassWhite : compassBlack;

    const toggleExpanded = () => setExpanded((prev) => !prev);

    return (
        createPortal(
            // <Control position={position}>
            <Box sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                pointerEvents: 'auto',
                marginTop: { xs: '8px', md: '10px' },
                marginLeft: { xs: '8px', md: '10px' }
            }}>
                <Box
                    onClick={toggleExpanded}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'var(--background-paper)',
                        border: '1px solid var(--border-default)',
                        borderRadius: { xs: '6px', md: '8px' },
                        boxShadow: 'var(--shadow-md)',
                        backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)',
                        transition: 'all 0.2s ease-in-out',
                        cursor: 'pointer',
                        overflow: 'hidden',
                        // Свернутое состояние — как у других контролов
                        ...(expanded
                            ? {
                                width: { xs: '200px', md: '300px' },
                                height: { xs: '200px', md: '300px' },
                            }
                            : {
                                width: { xs: '28px', md: '34px' },
                                height: { xs: '28px', md: '34px' },
                            }),
                    }}
                >
                    {expanded ? (
                        <Box
                            component="img"
                            src={compassImg}
                            alt="Компас"
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    ) : (
                        <IconButton
                            disableRipple
                            sx={{
                                width: '100%',
                                height: '100%',
                                minWidth: { xs: '28px', md: '34px' },
                                minHeight: { xs: '28px', md: '34px' },
                                borderRadius: { xs: '5px', md: '7px' },
                                color: 'var(--text-primary)',
                                '&:hover': {
                                    backgroundColor: 'var(--selected-bg)',
                                },
                            }}
                        >
                            <ExploreIcon sx={{ fontSize: { xs: '18px', md: '20px' } }} />
                        </IconButton>
                    )}
                </Box>
            </Box>
            , document.getElementsByClassName('leaflet-top leaflet-left')[0])
    );
};

export default CompassControl;
